"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFields = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
var FormFields = function (_a) {
    var user = _a.user, plan = _a.plan, setPlan = _a.setPlan;
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(storybook_1.Forms.Field, null,
            react_1.default.createElement(storybook_1.Forms.Input, { name: 'label', value: plan.label, placeholder: 'Titel van het abonnement', onChange: function (label) { return setPlan({ label: label }); } })),
        react_1.default.createElement(storybook_1.Forms.Field, null,
            react_1.default.createElement(storybook_1.Forms.Textarea, { name: 'description', value: plan.description, placeholder: 'Omschrijving', onChange: function (description) { return setPlan({ description: description }); } })),
        react_1.default.createElement(storybook_1.Forms.Container, null,
            user.is_admin && react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(storybook_1.Forms.Field, null,
                    react_1.default.createElement(storybook_1.Texts.Primary, null, "INTERVAL"),
                    react_1.default.createElement(storybook_1.Forms.Select, { value: plan.interval, onChange: function (interval) { return setPlan({ interval: interval }); } },
                        react_1.default.createElement("option", { value: '5 minute' }, "5 minuten"),
                        react_1.default.createElement("option", { value: '10 minute' }, "10 minuten"),
                        react_1.default.createElement("option", { value: '30 minute' }, "30 minuten"),
                        react_1.default.createElement("option", { value: '1 day' }, "Dagelijks"),
                        react_1.default.createElement("option", { value: '1 month' }, "Maandelijks"),
                        react_1.default.createElement("option", { value: '1 year' }, "Jaarlijks")))),
            plan.type === 'limited' &&
                react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(storybook_1.Forms.Field, null,
                        react_1.default.createElement(storybook_1.Texts.Primary, null, "EIND DATUM"),
                        react_1.default.createElement(storybook_1.Forms.Input, { type: 'date' }))),
            react_1.default.createElement(storybook_1.Forms.Group, null,
                react_1.default.createElement(storybook_1.Forms.Field, { className: 'w-full mr-4' },
                    react_1.default.createElement(storybook_1.Texts.Primary, null, "MAANDELIJKS"),
                    react_1.default.createElement(storybook_1.Forms.Input, { name: 'value', type: 'number', symbol: 'euro', value: String(plan.month), placeholder: 'Bedrag', onChange: function (month) { return setPlan({ month: month }); } })),
                react_1.default.createElement(storybook_1.Forms.Field, { className: 'w-full' },
                    react_1.default.createElement(storybook_1.Texts.Primary, null, "JAARLIJKS"),
                    react_1.default.createElement(storybook_1.Forms.Input, { name: 'value', type: 'number', symbol: 'euro', placeholder: 'Bedrag', value: String(plan.year), onChange: function (year) { return setPlan({ year: year }); } })))));
};
exports.FormFields = FormFields;
exports.FormFields.propTypes = {
    /**
     * The Model
     */
    plan: prop_types_1.default.shape({
        name: prop_types_1.default.string,
        label: prop_types_1.default.string,
        value: prop_types_1.default.float,
        description: prop_types_1.default.string,
    }),
    /**
     * Set the Model
     */
    setPlan: prop_types_1.default.func,
};
exports.FormFields.defaultProps = {};
